import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Seperator } from './Seperator';
import './css/GroupInfoModal.css';

export function FunctionModal({ shown, closeModal, group }) {
    const [functions, setFunctions] = useState([]);
    useEffect(() => {
        if (shown) {
            $('#permission-modal-container').fadeIn(300);
            $('#permission-modal-container').css('display', 'flex');
            $('#permission-modal').css({ "margin-left": "2000px" }).animate({ "margin-left": "0px" }, 300)
            fetchFunction();
        }
    }, [shown])

    function fetchFunction() {
        fetch(`/api/functions/`)
            .then((response) => response.json())
            .then((allFunctions) => {
                setFunctions(allFunctions);
                fetch(`/api/groups/${group.uuid}/functions/`)
                    .then((response) => response.json())
                    .then((result) => {
                        allFunctions.forEach((f) => {
                            if (result.find(tag => tag.function_UUID == f.uuid)) {
                                $(`#input-${f.uuid}`).prop('checked', true);
                            }
                            else {
                                $(`#input-${f.uuid}`).prop('checked', false);
                            }
                        })
                    })
            })
    }

    function handleSave() {
        let tag = {};
        functions.forEach(f => {
            tag[f.uuid] = $(`#input-${f.uuid}`).is(':checked');
        });
        console.log(tag)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify(tag),
            redirect: 'follow'
        };

        fetch(`/api/groups/${group.uuid}/functions`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
            })
            .catch(error => console.log('error', error));
    }

    return (
        <>
            <div className="group-info-container" id="permission-modal-container"
                onClick={() => {
                    if ($('#permission-modal-container').is(":visible")) {
                        closeModal();
                        $('#permission-modal-container').fadeOut(300);
                        $('#permission-modal').css("margin-left", "0px")
                            .animate({ "margin-left": "2000px" }, 300);
                    }
                }}>
                <div className="group-info" id="permission-modal" onClick={(e) => { e.stopPropagation() }}>
                    <div className="bar">
                        <div className="info-title">
                            Group Name:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF" }}>
                            {group?.name}
                        </div>
                    </div>
                    <Seperator width={726} />
                    <div className="bar">
                        <div className="info-title">
                            Permission:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF" }}>
                            {functions.map((f) => {
                                return (
                                    <div className="form-check" key={f.uuid}>
                                        <input className="form-check-input" type="checkbox" id={`input-${f.uuid}`} />
                                        <label className="form-check-label" htmlFor={`input-${f.uuid}`}>
                                            {f.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <button onClick={() => { handleSave() }}>Save</button>
                </div>
            </div>
        </>
    );
}
